<template>
  <div
    class="border rounded mt-4 mb-4"
    v-if="order && order.invoice && !$root.isEmptyObject(order.invoice)"
  >
    <h5 class="bg-light text-center rounded py-2 font-bold">
      اطلاعات پرداخت
    </h5>
    <div class="px-4 pb-4">
      <b-collapse visible>
        <div class="row">
          <div class="col-md-4 d-flex align-items-center mt-2">
            <h6 class="font-bold">وضعیت پرداخت :</h6>
            <h6 class="pr-1">
              <span
                v-if="order.invoice.status == 'failed'"
                class="badge badge-danger status"
              >
                ناموفق
              </span>
              <span
                v-else-if="order.invoice.status == 'success'"
                class="badge badge-success status"
              >
                موفق
              </span>
              <span
                v-else-if="order.invoice.status == 'pending'"
                class="badge badge-danger status"
              >
                در حال انتظار
              </span>
            </h6>
          </div>
          <div class="col-md-4 d-flex align-items-center mt-2">
            <h6 class="font-bold">مبلغ پرداختی :</h6>
            <h6 class="pr-1">
              <span>{{ order.invoice.payable_price | price }}</span>
              تومان
            </h6>
          </div>
          <div class="col-md-4 d-flex align-items-center mt-2">
            <h6 class="font-bold">مبلغ تخفیف :</h6>
            <h6 class="pr-1">
              <span v-if="order.invoice.total_discount">{{
                order.invoice.total_discount | price
              }}</span>
              <span v-else>ندارد</span>
            </h6>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import OrderInvoicesImpl from "@@/core/components/order/OrderInvoices/OrderInvoicesImpl";

export default {
  name: "OrderInvoices",
  extends: OrderInvoicesImpl,
};
</script>

<style
  scoped
  src="@@/core/components/order/OrderInvoices/OrderInvoicesStyle.css"
></style>
